import { render, staticRenderFns } from "./LinkInfoCard.vue?vue&type=template&id=6390bf8a&scoped=true"
import script from "./LinkInfoCard.vue?vue&type=script&lang=js"
export * from "./LinkInfoCard.vue?vue&type=script&lang=js"
import style0 from "./LinkInfoCard.vue?vue&type=style&index=0&id=6390bf8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390bf8a",
  null
  
)

export default component.exports